import { useState } from "react";
import { useDispatch } from "react-redux";

import * as Api from "@/api";
import Avatar from "@/design/components/Avatar";
import { showSnackbar } from "@/store/reducers/app";
import Valkyrie, { viMusic, viSpinnerThird } from "@sippy-platform/valkyrie";

import { ListItem, ListItemAvatar, ListItemButton, ListItemIcon, ListItemText } from "@mui/material";
import PropTypes from "prop-types";

function SoundItem({ musicOnHold, musicOnHoldDispatch, sound, closeDrawer }) {
  const dispatch = useDispatch();

  const [pending, setPending] = useState(false);

  // Entries
  const addSound = (sound) => {
    if (musicOnHold.entries.length >= 10) {
      dispatch(showSnackbar("You have reached the maximum number of audio files in your playlist."));
      return;
    }

    setPending(true);

    const newEntry = {
      soundId: sound.id,
      position: musicOnHold.entries.length + 1,
    };

    Promise.resolve(Api.postMusicOnHoldEntry(musicOnHold, newEntry))
      .then((response) => musicOnHoldDispatch({ type: "addSound", entry: { ...newEntry, id: response.data.entry.id } }))
      .finally(() => setPending(false));
  };

  return (
    <ListItem disablePadding sx={{ minHeight: 44 }}>
      <ListItemButton
        key={sound.id}
        onClick={() => {
          addSound(sound);
          if (musicOnHold?.entries.length >= 9) closeDrawer();
        }}
        sx={{ minHeight: 44 }}
        disabled={pending}
      >
        <ListItemAvatar>
          <Avatar text={sound.name} px={24} icon={viMusic} />
        </ListItemAvatar>
        <ListItemText primary={sound.name} />
        {pending && (
          <ListItemIcon sx={{ minWidth: 16 }}>
            <Valkyrie icon={viSpinnerThird} spin />
          </ListItemIcon>
        )}
      </ListItemButton>
    </ListItem>
  );
}

SoundItem.propTypes = {
  musicOnHold: PropTypes.object,
  musicOnHoldDispatch: PropTypes.func,
  sound: PropTypes.object,
  closeDrawer: PropTypes.func,
};

export default SoundItem;
